var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{staticStyle:{"width":"120px"},attrs:{"type":"number"},model:{value:(_vm.value.delay),callback:function ($$v) {_vm.$set(_vm.value, "delay", $$v)},expression:"value.delay"}}),_vm._v("ms ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }